import classNames from 'classnames';
import { graphql } from 'gatsby';
import parse from 'html-react-parser';

type ProductPresentationProps = Queries.ProductPresentationFragmentFragment;

export const ProductPresentation = ({
  presentation,
}: ProductPresentationProps) => (
  <section className='product-presentation'>
    <div className='description'>
      {presentation?.text_sections?.map((textSection) => (
        <div key={textSection!.id}>
          <h3>{textSection!.title}</h3>
          {textSection!.body?.data && (
            <div>{parse(textSection!.body.data.body)}</div>
          )}
          <br />
        </div>
      ))}
    </div>
    <div className='images'>
      {presentation?.image_sections?.map((imageSection) => (
        <div
          className={classNames('image', imageSection!.layout)}
          key={imageSection!.id}
        >
          {imageSection!.featured_image && (
            <img
              alt={imageSection!.featured_image.alternativeText!}
              src={imageSection!.featured_image.localFile!.publicURL!}
            />
          )}
          {imageSection!.caption?.data && (
            <div>{parse(imageSection!.caption.data.caption)}</div>
          )}
        </div>
      ))}
    </div>
    {presentation?.color_sections?.map((colorSection) => (
      <div className={'color-group'} key={colorSection!.id}>
        <h5>{colorSection!.title}</h5>
        {colorSection!.subtitle && <h3>{colorSection!.subtitle}</h3>}
        {colorSection!.colors?.map((color) => (
          <div className={'single-color'} key={color!.id}>
            <div
              className={'color'}
              style={{
                backgroundImage: color!.texture_image?.localFile
                  ? `url(${color!.texture_image.localFile.publicURL!})`
                  : undefined,
                backgroundColor: color!.code!,
              }}
            />
            <div className={'description'}>{color!.title}</div>
          </div>
        ))}
      </div>
    ))}
  </section>
);

export const query = graphql`
  fragment ProductPresentationFragment on STRAPI_PRODUCT {
    presentation {
      color_sections {
        colors {
          code
          id
          subtitle
          texture_image {
            localFile {
              publicURL
            }
          }
          title
        }
        id
        subtitle
        title
      }
      image_sections {
        caption {
          data {
            caption
          }
        }
        featured_image {
          alternativeText
          localFile {
            id
            publicURL
          }
        }
        id
        layout
      }
      text_sections {
        body {
          data {
            body
          }
        }
        id
        title
      }
    }
  }
`;
